export const COLORS = {
    primary: '#5C9B59',
    secondary: '#F6BB17',
    secondaryOff: '#BD9012',
    secondaryBorder: '#9D7609',
    textDark: '#090A0A',
    textLight: '#FFFFFF',
    backgroundColor: '#F6F6F6',
    border: '#757575',
    easyBackground: '#DDEFE2', 
    easy: '#007951',          
    moderateBackground: '#FDE9D9',
    moderate: '#D66100',
    difficultBackground: '#F9E0E0',
    difficult: '#A20202',
    descriptionText: '#49454F',
    green: '#085504',          
    greenBackground: '#D8EFD3', 
    blue: '#0B60B0',            
    blueBackground: '#E0E9F2',  
};
